function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/TOOLS/ico-30-text-title");

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M6.772,21.564 L7.672,18.576 L11.866,18.576 L12.766,21.564 L15.61,21.564 L11.524,9 L8.14,9 L4,21.564 L6.772,21.564 Z M11.2,16.254 L8.32,16.254 L9.706,11.484 L9.796,11.484 L11.2,16.254 Z M19.57,21.78 C20.29,21.78 20.896,21.621 21.388,21.303 C21.88,20.985 22.198,20.52 22.342,19.908 L22.342,19.908 L22.45,19.908 C22.534,20.412 22.735,20.814 23.053,21.114 C23.371,21.414 23.77,21.564 24.25,21.564 L24.25,21.564 L25.726,21.564 L25.726,19.494 L24.844,19.494 L24.844,15.354 C24.844,14.226 24.508,13.368 23.836,12.78 C23.164,12.192 22.156,11.898 20.812,11.898 C19.816,11.898 19.027,12.057 18.445,12.375 C17.863,12.693 17.38,13.134 16.996,13.698 L16.996,13.698 L18.58,15.102 C18.784,14.814 19.042,14.556 19.354,14.328 C19.666,14.1 20.086,13.986 20.614,13.986 C21.178,13.986 21.58,14.121 21.82,14.391 C22.06,14.661 22.18,15.024 22.18,15.48 L22.18,15.48 L22.18,16.074 L20.686,16.074 C19.438,16.074 18.451,16.317 17.725,16.803 C16.999,17.289 16.636,18.03 16.636,19.026 C16.636,19.854 16.888,20.52 17.392,21.024 C17.896,21.528 18.622,21.78 19.57,21.78 Z M20.56,19.926 C20.164,19.926 19.858,19.845 19.642,19.683 C19.426,19.521 19.318,19.266 19.318,18.918 L19.318,18.918 L19.318,18.648 C19.318,17.94 19.84,17.586 20.884,17.586 L20.884,17.586 L22.18,17.586 L22.18,18.702 C22.18,19.134 22.021,19.446 21.703,19.638 C21.385,19.83 21.004,19.926 20.56,19.926 Z",
  id: "path-1"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-6.0%",
  y: "-9.0%",
  width: "118.2%",
  height: "129.7%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feMorphology", {
  radius: 0.4,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/TOOLS/ico-30-text-title",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Aa"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFFFFF",
  strokeWidth: 0.4,
  d: "M20.812,11.698 C22.217964,11.698 23.2664341,12.0158761 23.9677009,12.6294847 C24.6789963,13.2518681 25.044,14.1568029 25.044,15.354 L25.044,15.354 L25.044,19.294 L25.926,19.294 L25.926,21.764 L24.2432025,21.764 C23.5982129,21.7206227 23.2239413,21.5502197 22.9157559,21.2594787 C22.6868266,21.0435077 22.511899,20.7798225 22.3927611,20.4674692 C22.1279407,20.9391656 21.853693,21.2401425 21.4965653,21.470969 C20.9751846,21.8079589 20.3337723,21.98 19.57,21.98 C18.5573783,21.98 17.7873042,21.702147 17.2505786,21.1654214 C16.7109048,20.6257475 16.436,19.9141307 16.436,19.026 C16.436,17.9527045 16.8334652,17.1591364 17.6137432,16.6368016 C18.367022,16.1325406 19.3895549,15.874 20.686,15.874 L20.686,15.874 L21.98,15.874 C21.9514535,15.0083275 21.8562878,14.7328636 21.6705181,14.5238728 C21.4602658,14.2873389 21.101629,14.186 20.614,14.186 C20.1371081,14.186 19.7547834,14.2828312 19.4720033,14.4894782 C19.112093,14.7524896 18.8279898,15.0574401 18.6209853,15.4055836 L18.6209853,15.4055836 L16.7265328,13.7264098 C17.302639,12.9296966 17.7816698,12.5095308 18.3491028,12.1994901 C18.9546821,11.8686066 19.7745782,11.698 20.812,11.698 Z M21.98,17.786499 L20.7056817,17.7896741 C20.3025286,17.8069209 19.9883081,17.8827632 19.7881691,18.0961237 C19.6016086,18.2950087 19.522934,18.6048667 19.5245629,19.0509114 C19.5459854,19.2573486 19.620982,19.4172365 19.762,19.523 C19.9497647,19.6638235 20.2179877,19.726 20.56,19.726 C20.9632865,19.726 21.3103864,19.6414225 21.5996262,19.4667871 C21.8594577,19.3099077 21.98,19.051093 21.98,18.702 L21.98,17.786499 Z M11.6692677,8.8 L15.8853537,21.764 L12.6173655,21.764 L11.7173655,18.776 L7.82063453,18.776 L6.92063453,21.764 L3.72351929,21.764 L7.99532445,8.8 L11.6692677,8.8 Z M9.71318041,12.1760678 L8.58638501,16.054 L10.9277781,16.054 L9.71318041,12.1760678 Z",
  fill: "#000000",
  fillRule: "evenodd"
}))));

const SvgIco30TextTitle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30TextTitle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-text-title.bcda81f5.svg";
export { ForwardRef as ReactComponent };